module.exports = "<div class=\"modal fade\" [attr.id]=\"id\" role=\"dialog\" aria-labelledby=\"delete-user\" [class.force-to-top]=\"forceToTop\">\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/modal/modal.template.html
// module id = ../../../../../src/app/shared/components/modal/modal.template.html
// module chunks = 12